import { pushWorkyMarketingAnalyticsEvent } from './pushWorkyMarketingAnalyticsEvent';
import { TAG_DICTIONARY } from './TagDictionary';

const EXTERNAL_WORKY_CALENDLY_DEMO_BOOKING_URL: string =
  'https://calendly.com/worky-pro/30min';

/**
 * Sends `cta_click` then opens Worky demo booking (new tab).
 */
const openWorkyCalendlyDemoInNewTab = (
  ctaId: string,
  ctaLabel?: string,
): void => {
  pushWorkyMarketingAnalyticsEvent({
    event: TAG_DICTIONARY.EVENTS.CTA_CLICK,
    cta_id: ctaId,
    ...(ctaLabel !== undefined ? { cta_label: ctaLabel } : {}),
  });
  window.open(
    EXTERNAL_WORKY_CALENDLY_DEMO_BOOKING_URL,
    '_blank',
    'noopener,noreferrer',
  );
};

export { EXTERNAL_WORKY_CALENDLY_DEMO_BOOKING_URL, openWorkyCalendlyDemoInNewTab };
